import { render, staticRenderFns } from "./PublicLogo.vue?vue&type=template&id=1f8a6cfc&lang=pug&"
import script from "./PublicLogo.vue?vue&type=script&lang=js&"
export * from "./PublicLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports